var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { fetcher } from "@/api/schema";
import { useUserStore } from "@/stores/userStore";
import { withPrefix } from "@/utils/redirect";
const getWorkflows = fetcher.path("/api/workflows").method("get").create();
export function loadWorkflows({ sortBy = "update_time", sortDesc = true, limit = 20, offset = 0, filterText = "", showPublished = false, skipStepCounts = true, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, headers } = yield getWorkflows({
            sort_by: sortBy,
            sort_desc: sortDesc,
            limit,
            offset,
            search: filterText,
            show_published: showPublished,
            skip_step_counts: skipStepCounts,
        });
        return { data, headers };
    });
}
export function updateWorkflow(id, changes) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.put(withPrefix(`/api/workflows/${id}`), changes);
        return data;
    });
}
export function copyWorkflow(id, currentOwner) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { data: workflowData } = yield axios.get(withPrefix(`/api/workflows/${id}/download`));
        workflowData.name = `Copy of ${workflowData.name}`;
        const currentUsername = (_a = useUserStore().currentUser) === null || _a === void 0 ? void 0 : _a.username;
        if (currentUsername !== currentOwner) {
            workflowData.name += ` shared by user ${currentOwner}`;
        }
        const { data } = yield axios.post(withPrefix("/api/workflows"), { workflow: workflowData });
        return data;
    });
}
export function deleteWorkflow(id) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.delete(withPrefix(`/api/workflows/${id}`));
        return data;
    });
}
export function undeleteWorkflow(id) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.post(withPrefix(`/api/workflows/${id}/undelete`));
        return data;
    });
}
export function createWorkflow(workflowName, workflowAnnotation) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.put(withPrefix("/workflow/create"), {
            workflow_name: workflowName,
            workflow_annotation: workflowAnnotation,
        });
        return data;
    });
}
export function getWorkflowFull(workflowId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.get(withPrefix(`/workflow/load_workflow?_=true&id=${workflowId}`));
        return data;
    });
}
export function getWorkflowInfo(workflowId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.get(withPrefix(`/api/workflows/${workflowId}`));
        return data;
    });
}
